import ListLabel from '@/components/ListLabel/ListLabel';
import { ROUTE_DASHBOARD_BOOKING_PAGE } from '@/constants/routes';
import useAuth from '@/hooks/useAuth';
import HeaderTemplate from '@/templates/Header.template';
import PageSectionTemplate from '@/templates/PageSection.template';
import WithQuery from '@/utils/WithQuery';
import { Box, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FiPlus } from 'react-icons/fi';
import BookingPageItem from './components/BookingPageItem';
import NoServicesBanner from './components/NoServicesBanner';
import useEventList from './useEventList';

export default WithQuery({
	useHook: useEventList,
	Component: function EventListPage(props) {
		const { t } = useTranslation();
		const auth = useAuth();

		const ownedBookingPages = props.eventTypes.filter((e) => e.userId === auth.getCurrentUser().userId);
		const sharedBookingPages = props.eventTypes.filter((e) => e.userId !== auth.getCurrentUser().userId);

		return (
			<PageSectionTemplate>
				<HeaderTemplate
					left={<></>}
					center={t('Services')}
					right={
						<Button onClick={props.createEventType} colorScheme="primary" size="sm" rightIcon={<FiPlus />}>
							{props.t('Create')}
						</Button>
					}
				/>

				<Box display="flex" flexDir="column" w="100%" h="full" overflow="auto">
					{props.eventTypes.length === 0 ? <NoServicesBanner /> : null}

					{ownedBookingPages.length > 0 ? (
						<>
							<ListLabel>{t('My services')}</ListLabel>
							<Box>
								{ownedBookingPages.map((bookingPage) => (
									<BookingPageItem
										key={bookingPage.id}
										bookingPage={bookingPage}
										link={ROUTE_DASHBOARD_BOOKING_PAGE.replace(':id', bookingPage.id)}
										onCopyLinkClick={() => props.copyLink(bookingPage)}
									/>
								))}
							</Box>
						</>
					) : null}

					{sharedBookingPages.length ? (
						<>
							<ListLabel>{t('Services shared with me')}</ListLabel>
							<Box>
								{sharedBookingPages.map((bookingPage) => (
									<BookingPageItem
										key={bookingPage.id}
										bookingPage={bookingPage}
										link={ROUTE_DASHBOARD_BOOKING_PAGE.replace(':id', bookingPage.id)}
										onCopyLinkClick={() => props.copyLink(bookingPage)}
									/>
								))}
							</Box>
						</>
					) : null}
				</Box>
			</PageSectionTemplate>
		);
	},
});
